"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createChildIdentities = exports.prepareStorage = exports.getAuthorization = exports.prepareCreateChildIdentities = exports.createChildIdentityResolver = void 0;
const internal_1 = require("../../internal");
const types_1 = require("../../types");
const conversion_1 = require("../../utils/conversion");
const internal_2 = require("../../utils/internal");
/**
 * @hidden
 */
const createChildIdentityResolver = (context) => (receipt) => {
    const childDids = (0, internal_2.filterEventRecords)(receipt, 'identity', 'ChildDidCreated');
    return childDids.map(({ data }) => new internal_1.ChildIdentity({ did: (0, conversion_1.identityIdToString)(data[1]) }, context));
};
exports.createChildIdentityResolver = createChildIdentityResolver;
/**
 * @hidden
 */
function prepareCreateChildIdentities(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const { context: { polymeshApi: { tx }, }, context, storage: { identity: { did: signingDid }, }, } = this;
        const { childKeyAuths, expiresAt } = args;
        if (expiresAt <= new Date()) {
            throw new internal_1.PolymeshError({
                code: types_1.ErrorCode.ValidationError,
                message: 'Expiry date must be in the future',
            });
        }
        const childIdentity = new internal_1.ChildIdentity({ did: signingDid }, context);
        const [parentDid, ...identities] = yield Promise.all([
            childIdentity.getParentDid(),
            ...childKeyAuths.map(({ key }) => (0, internal_2.asAccount)(key, context).getIdentity()),
        ]);
        if (parentDid) {
            throw new internal_1.PolymeshError({
                code: types_1.ErrorCode.UnmetPrerequisite,
                message: 'The signing Identity is already a child Identity and cannot create further child identities',
                data: {
                    parentDid,
                },
            });
        }
        if (identities.some(identityValue => identityValue !== null)) {
            throw new internal_1.PolymeshError({
                code: types_1.ErrorCode.UnmetPrerequisite,
                message: 'One or more accounts are already linked to some Identity',
            });
        }
        const rawExpiry = (0, conversion_1.dateToMoment)(expiresAt, context);
        return {
            transaction: tx.identity.createChildIdentities,
            args: [(0, conversion_1.childKeysWithAuthToCreateChildIdentitiesWithAuth)(childKeyAuths, context), rawExpiry],
            resolver: (0, exports.createChildIdentityResolver)(context),
        };
    });
}
exports.prepareCreateChildIdentities = prepareCreateChildIdentities;
/**
 * @hidden
 */
function getAuthorization() {
    return __awaiter(this, void 0, void 0, function* () {
        const { storage: { identity, actingAccount }, } = this;
        const { account: primaryAccount } = yield identity.getPrimaryAccount();
        if (!actingAccount.isEqual(primaryAccount)) {
            return {
                signerPermissions: "Child Identities can only be created by an Identity's primary Account",
            };
        }
        return {
            permissions: {
                transactions: [types_1.TxTags.identity.CreateChildIdentities],
                assets: [],
                portfolios: [],
            },
        };
    });
}
exports.getAuthorization = getAuthorization;
/**
 * @hidden
 */
function prepareStorage() {
    return __awaiter(this, void 0, void 0, function* () {
        const { context } = this;
        const [identity, actingAccount] = yield Promise.all([
            context.getSigningIdentity(),
            context.getActingAccount(),
        ]);
        return {
            identity,
            actingAccount,
        };
    });
}
exports.prepareStorage = prepareStorage;
/**
 * @hidden
 */
const createChildIdentities = () => new internal_1.Procedure(prepareCreateChildIdentities, getAuthorization, prepareStorage);
exports.createChildIdentities = createChildIdentities;
//# sourceMappingURL=createChildIdentities.js.map